import React from 'react';
import { useMutation } from '@apollo/client';
import useLogout from '@hooks/useLogout';
import useLocaleForQueries from '@hooks/useLocaleForQueries';
import { ACCEPT_TERMS } from '@graphql/operations/consent/acceptTerms';
import TermsAndConditions from './TermsAndConditions';

interface TermsProps {
  id?: string;
  onAccept: () => void;
  title?: string;
  terms?: string;
}

export function Terms({ id, onAccept, title, terms }: TermsProps): JSX.Element {
  const locale = useLocaleForQueries();
  const [acceptTerms] = useMutation(ACCEPT_TERMS);
  const onClickAccept = () => {
    acceptTerms({ variables: { termsId: id, locale } });
    onAccept();
  };
  const logout = useLogout();
  const onClickDecline = () => logout();

  return <TermsAndConditions title={title} terms={terms} onAccept={onClickAccept} onDecline={onClickDecline} />;
}

export default Terms;
